export const sendProduct = {
  name: 'Send',
  displayName: {
    source: {
      jsonPath: '$.displayName',
      resource: 'tenant',
    },
  },
  description:
    'Make email simple and transform campaign results with an AI-powered marketing automation solution.',
  icon: {
    type: 'url',
    src: 'https://sitecorecontenthub.stylelabs.cloud/api/public/content/27395bd42ca54b0486190233a0349509',
  },
  color: 'red',
  baseUrl: {
    dev: 'https://auth.sitecoresendstaging.io',
    qa: 'https://auth.sitecoresendstaging.io',
    staging: 'https://auth.sitecoresendstaging.io',
    'pre-production': 'https://auth.sitecoresendstaging.io',
    production: 'https://auth.sitecoresend.io',
  },
  link: {
    type: 'external-link',
    to: '{baseUrl}/Send?tenantId={tenantId}&organization={organizationId}',
    replacements: [
      {
        key: 'baseUrl',
        source: {
          jsonPath: "$.baseUrl['#env#']",
          resource: '_self',
        },
      },
      {
        key: 'tenantId',
        source: {
          resource: 'tenant',
          jsonPath: '$.id',
        },
      },
      {
        key: 'organizationId',
        source: {
          resource: 'tenant',
          jsonPath: '$.organizationId',
        },
      },
    ],
  },
};
